import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-cocina',
  templateUrl: './cocina.component.html',
  styleUrls: ['./cocina.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CocinaComponent {
  constructor() {}
}
